module.exports = __webpack_public_path__ + "img/drapeauLnb.4000539a.jpg";